import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, createVNode as _createVNode, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, createSlots as _createSlots, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7c87b5a1"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 1,
  class: "grid-loading-pane"
}
const _hoisted_2 = { class: "custom-header" }
const _hoisted_3 = { class: "main-title" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "dx-icon dx-icon-close" }, null, -1))
const _hoisted_5 = [
  _hoisted_4
]

import { DxPopover } from 'devextreme-vue/popover';
import ScrollView from '../scroll-view.vue';
import { computed } from 'vue';
import DxLoadIndicator from 'devextreme-vue/load-indicator';


export default /*#__PURE__*/_defineComponent({
  __name: 'popover-base',
  props: {
    /** 
     * The boolean value used with `v-model` to control the visibility or state of a modal or component.
     * @type {boolean}
     * @required
     */
    modelValue: {
        type: Boolean,
        required: true
    },

    /** 
     * The height of the component. Accepts valid CSS height values (e.g., '100px', '50%', 'auto').
     * @type {string}
     * @default 'auto'
     */
    height: {
        type: String,
        default: 'auto'
    },

    /** 
     * The width of the component. Accepts valid CSS width values (e.g., '100px', '50%', 'auto').
     * @type {string}
     * @default 'auto'
     */
    width: {
        type: String,
        default: 'auto'
    },

    /** 
     * The target element or identifier that this component interacts with.
     * Typically used to specify a container or trigger.
     * @type {string}
     * @required
     */
    target: {
        type: String,
        required: true
    },

    /** 
     * Determines whether to show the Close button.
     * If `true`, a close button will be displayed.
     * @type {boolean}
     * @default true
     */
    showCloseButton: {
        type: Boolean,
        default: true
    },

    /** 
     * The title or heading associated with the component.
     * This is typically displayed at the top of the modal or component.
     * @type {string}
     */
    title: {
        type: String,
        required: false
    },

    /** 
     * Determines whether the component is in a loading state.
     * If `true`, loading indicators may be displayed.
     * @type {boolean}
     * @default false
     */
    loading: {
        type: Boolean,
        default: false
    }
},
  emits: [
    /** 
     * Emitted when the `modelValue` is updated.
     * This allows the parent component to sync the visibility state of the popover.
     * @param {boolean} value - The new visibility state of the popover.
     */
    'update:modelValue', 

    /** 
     * Emitted when the popover is displayed.
     * Can be used to trigger actions when the popover becomes visible.
     */
    'popupDisplayed'
],
  setup(__props, { emit }) {

const props = __props;





const showPopOver = computed({
    get: () => props.modelValue,
    set: (value: Boolean) => emit('update:modelValue', value)
});

const closeModal = () => {
    showPopOver.value = false;
};

const animationConfig = {
    show: {
        type: 'slide',
        from: {
            position: { my: 'top left', at: 'bottom right', of: ".layout-header" },
            opacity: 0
        },
        to: {
            position: { my: 'top right', at: 'bottom right', of: ".layout-header" },
            opacity: 1
        }
    },
    hide: {
        type: 'fade',
        from: 1,
        to: 0
    }
};

const position = {
    at: 'bottom right',
    offset: {
        x: 0,
        y: 3
    },
    boundaryOffset: {
        x: 0,
        y: 0
    }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(DxPopover), {
    visible: showPopOver.value,
    "onUpdate:visible": _cache[0] || (_cache[0] = ($event: any) => ((showPopOver).value = $event)),
    target: props.target,
    onShowing: _cache[1] || (_cache[1] = ($event: any) => (emit('popupDisplayed'))),
    height: props.height,
    width: props.width,
    "show-title": true,
    showCloseButton: props.showCloseButton,
    title: props.title,
    animation: animationConfig,
    position: position
  }, _createSlots({
    content: _withCtx(() => [
      (!__props.loading)
        ? (_openBlock(), _createBlock(ScrollView, { key: 0 }, {
            default: _withCtx(() => [
              _renderSlot(_ctx.$slots, "content")
            ]),
            _: 3
          }))
        : (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createVNode(_unref(DxLoadIndicator), {
              height: 50,
              width: 50
            })
          ]))
    ]),
    _: 2
  }, [
    (props.showCloseButton && !props.title)
      ? {
          name: "title",
          fn: _withCtx(() => [
            _createElementVNode("section", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _renderSlot(_ctx.$slots, "title")
              ]),
              _createElementVNode("div", { class: "icon-section" }, [
                _createElementVNode("div", {
                  class: "close-button-holder",
                  onClick: closeModal
                }, _hoisted_5)
              ])
            ])
          ]),
          key: "0"
        }
      : undefined
  ]), 1032, ["visible", "target", "height", "width", "showCloseButton", "title"]))
}
}

})